export default __webpack_public_path__ + "static/media/mShorts_1_p1.8ddd51ba.jpeg";